'use strict';

var weechat = angular.module('weechat');

// Shared state for the single context menu popup instance. Any number of
// contextMenu-triggering elements can call open() on this; only one menu
// is ever shown at a time.
weechat.factory('contextMenuService', [function() {
    var state = {
        visible: false,
        x: 0,
        y: 0,
        items: []
    };

    var close = function() {
        state.visible = false;
        state.items = [];
    };

    var open = function(x, y, items) {
        state.x = x;
        state.y = y;
        state.items = items;
        state.visible = true;
    };

    return {
        state: state,
        open: open,
        close: close
    };
}]);

/*
 * Attribute directive that opens the shared context menu on right-click
 * (desktop) or long-press (touch). Usage:
 *   <li context-menu="getBufferContextMenuItems(buffer)">
 * The expression must evaluate to an array of {label, action} objects.
 */
weechat.directive('contextMenu', ['contextMenuService', function(contextMenuService) {
    var LONG_PRESS_MS = 500;
    var TOUCH_MOVE_TOLERANCE = 10;

    return {
        restrict: 'A',
        scope: {
            contextMenu: '&'
        },
        link: function(scope, element) {
            var longPressTimer = null;
            var touchStart = null;
            var suppressClick = false;

            function open(x, y) {
                var items = scope.contextMenu();
                if (items && items.length) {
                    scope.$applyAsync(function() {
                        contextMenuService.open(x, y, items);
                    });
                }
            }

            function cancelLongPress() {
                if (longPressTimer) {
                    clearTimeout(longPressTimer);
                    longPressTimer = null;
                }
                element.removeClass('context-menu-armed');
            }

            element.on('contextmenu', function(event) {
                event.preventDefault();
                open(event.clientX, event.clientY);
            });

            element.on('touchstart', function(event) {
                if (event.touches.length !== 1) {
                    return;
                }
                suppressClick = false;
                var touch = event.touches[0];
                touchStart = { x: touch.clientX, y: touch.clientY };
                longPressTimer = setTimeout(function() {
                    longPressTimer = null;
                    suppressClick = true;
                    element.addClass('context-menu-armed');
                    open(touchStart.x, touchStart.y);
                }, LONG_PRESS_MS);
            });

            element.on('touchmove', function(event) {
                if (!longPressTimer || !touchStart) {
                    return;
                }
                var touch = event.touches[0];
                if (Math.abs(touch.clientX - touchStart.x) > TOUCH_MOVE_TOLERANCE ||
                    Math.abs(touch.clientY - touchStart.y) > TOUCH_MOVE_TOLERANCE) {
                    cancelLongPress();
                }
            });

            element.on('touchend', function(event) {
                cancelLongPress();
                if (suppressClick) {
                    // Swallow the synthetic click that would otherwise
                    // follow this touch (e.g. setActiveBuffer/openBuffer).
                    event.preventDefault();
                    event.stopPropagation();
                }
            });

            element.on('touchcancel', cancelLongPress);

            scope.$on('$destroy', function() {
                element.off('contextmenu touchstart touchmove touchend touchcancel');
                cancelLongPress();
            });
        }
    };
}]);

// Renders the single shared context menu popup. Place once in index.html.
weechat.directive('contextMenuPopup', ['contextMenuService', '$document', '$timeout', function(contextMenuService, $document, $timeout) {
    return {
        restrict: 'E',
        template:
            '<ul class="dropdown-menu context-menu positioning" ng-if="menu.visible" ng-style="{top: menu.y + \'px\', left: menu.x + \'px\'}">' +
                '<li ng-repeat="item in menu.items"><a href="#" ng-click="run(item)">{{ item.label }}</a></li>' +
            '</ul>',
        link: function(scope, element) {
            scope.menu = contextMenuService.state;

            scope.run = function(item) {
                contextMenuService.close();
                item.action();
            };

            function onOutsideAction(event) {
                if (!scope.menu.visible) {
                    return;
                }
                // A tap/click that lands inside the menu itself isn't
                // "outside" — on touch this fires on touchstart, before the
                // item's own ng-click runs on touchend/click, so closing
                // here would remove the <a> before it ever registers the
                // tap (this is what made e.g. "Close buffer" appear dead
                // on mobile).
                if (event.target && element[0].querySelector('.context-menu') &&
                    element[0].querySelector('.context-menu').contains(event.target)) {
                    return;
                }
                scope.$apply(function() {
                    contextMenuService.close();
                });
            }

            function onKeydown(event) {
                if (scope.menu.visible && event.key === 'Escape') {
                    scope.$apply(function() {
                        contextMenuService.close();
                    });
                }
            }

            $document.on('click touchstart', onOutsideAction);
            $document.on('keydown', onKeydown);

            // Keep the menu fully on-screen: nudge it left/up if it would
            // overflow the viewport at the point it was opened.
            scope.$watch('menu.visible', function(visible) {
                if (!visible) {
                    return;
                }
                $timeout(function() {
                    var menuEl = element[0].querySelector('.context-menu');
                    if (!menuEl) {
                        return;
                    }
                    var rect = menuEl.getBoundingClientRect();
                    var margin = 8;
                    // visualViewport reflects the actual visible area under
                    // pinch-zoom on mobile; innerWidth/Height don't.
                    var viewportWidth = window.visualViewport ? window.visualViewport.width : window.innerWidth;
                    var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
                    var maxX = viewportWidth - rect.width - margin;
                    var maxY = viewportHeight - rect.height - margin;
                    scope.menu.x = Math.min(Math.max(margin, scope.menu.x), Math.max(margin, maxX));
                    scope.menu.y = Math.min(Math.max(margin, scope.menu.y), Math.max(margin, maxY));
                    // Reveal now that position is clamped — avoids a flash
                    // at the raw (possibly off-screen) touch/click point.
                    menuEl.classList.remove('positioning');
                });
            });

            scope.$on('$destroy', function() {
                $document.off('click touchstart', onOutsideAction);
                $document.off('keydown', onKeydown);
            });
        }
    };
}]);
